import type { LevelExtrusion } from "building-types/levels/levelPerimeters";
import type { Table } from "common/data/table";
import { closestPointPolyLine2 } from "geom/closestPoint";
import { classifyContainmentVec2PolyLine2Fast } from "geom/containment";

/**
 * Classifies containment in the building by approximating the building as a series of extruded prisms
 * defined by the floor plates.
 */
export default function pointInsideLevelExtrusions(
  levelExtrusions: Table<LevelExtrusion>,
  x: number,
  y: number,
  z: number,
  tolerance: number = 0,
) {
  for (const levelId in levelExtrusions) {
    const levelExtrusion = levelExtrusions[levelId];

    if (z >= levelExtrusion.minZ && z < levelExtrusion.maxZ) {
      for (const perimeter of levelExtrusion.perimeters) {
        if (classifyContainmentVec2PolyLine2Fast(x, y, perimeter)) {
          return true;
        } else if (tolerance > 0) {
          const cp = closestPointPolyLine2(perimeter, x, y);
          if (cp.dist < tolerance) {
            return true;
          }
        }
      }
    }
  }

  return false;
}
